import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-password-prompt',
    templateUrl: './password-prompt.component.html',
    styleUrls: ['./password-prompt.component.scss']
})
export class PasswordPromptComponent implements OnInit {
    passwordForm: FormGroup;

    constructor(
        public matDialogRef: MatDialogRef<PasswordPromptComponent>,
        private _formBuilder: FormBuilder,
    ) {
    }

    ngOnInit(): void {
        this.passwordForm = this._formBuilder.group({
            password: [''],
        });
    }

    onSubmit() {
        this.matDialogRef.close(this.passwordForm.get('password').value);
    }

}
